<template>
  <div
    ref="dropdown"
    class="inline-block"
  >
    <button
      type="button"
      class="focus-visible:outline-none focus-visible:border-peacock-300 focus-visible:ring-peacock-300 focus-visible:ring-offset-2  inline-flex h-10 w-max items-center justify-center rounded-sm border border-gray-300 px-4 py-2 text-sm hover:bg-gray-100 focus-visible:ring-2 text-black"
      :class="[
        {
          'bg-white': !isOpen,
          'bg-gray-100': isOpen,
          'font-semibold': isActive,
        },
      ]"
      @click="toggleOpen"
    >
      <slot name="label" />
      <YscIconsArrowBottom
        :class="{ 'rotate-180': isOpen }"
        class="ml-4 h-3 w-3 transition-transform duration-200"
      />
    </button>

    <div
      v-if="isOpen"
      class="absolute mt-2 rounded-sm border border-gray-300 bg-white shadow-lg"
      :class="slotAnchor"
    >
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
import { onClickOutside } from '@vueuse/core'

interface Props {
  open?: boolean
  isActive: boolean
  slotAnchor?: string | null
}

const props = withDefaults(defineProps<Props>(), {
  slotAnchor: null,
  open: undefined,
})

const emits = defineEmits<{
  'toggle-open': [MouseEvent]
  'close': []
}>()

const localeOpen = ref(false)

const isOpen = computed(() => props.open !== undefined ? props.open : localeOpen)

const toggleOpen = (evt: MouseEvent) => {
  if (props.open !== undefined) {
    emits('toggle-open', evt)
  }
  else {
    localeOpen.value = !localeOpen.value
  }
}

const close = () => {
  if (props.open !== false) {
    emits('close')
  }
  else {
    localeOpen.value = false
  }
}

const dropdown = ref(null)
onClickOutside(dropdown, () => close())
</script>
